"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoCardComponent = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Info_1 = require("../icons/Info");
var styles = require("../styles/InfoCardComponent");
var InfoCardComponent = function (props) {
    var title = props.title, tooltip = props.tooltip, value = props.value, description = props.description, width = props.width, height = props.height;
    var containerStyle = { width: width || 300, height: height };
    var getTooltipInfo = function () {
        if (tooltip) {
            return typeof tooltip === 'string' ? React.createElement("span", null, tooltip) : tooltip;
        }
        return null;
    };
    var isValidValue = value !== null && value !== undefined;
    return (React.createElement("div", { className: styles.infoCardContainerStyle, style: containerStyle },
        React.createElement("div", null,
            React.createElement("label", { className: styles.infoCardHeader }, title),
            "\u00A0",
            tooltip && (React.createElement(widgets_1.Tooltip, { getContent: getTooltipInfo },
                React.createElement("span", null, React.createElement(Info_1.Info, null))))),
        isValidValue && React.createElement("div", { className: styles.infoCardValue }, value),
        description));
};
exports.InfoCardComponent = InfoCardComponent;
//# sourceMappingURL=InfoCardComponent.js.map